import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {CommonModule} from '@angular/common';
import {CoreModule} from '../../core.module';
import {AdministrationDataPortalComponent} from './administration-data-portal.component';
import {CensusComponent} from './census/census.component';
import {AgeGroupsComponent} from './age-groups/age-groups.component';
import {BeneficiariesComponent} from './beneficiaries/beneficiaries.component';
import {AddCensusComponent} from './census/add-census/add-census.component';
import {AddBeneficiaryComponent} from './beneficiaries/add-beneficiary/add-beneficiary.component';
import {AddAgeRangeComponent} from './age-groups/add-age-range/add-age-range.component';
import {PolicyDocumentsComponent} from './policy-documents/policy-documents.component';
import {AddPolicyDocumentComponent} from './policy-documents/add-policy-document/add-policy-document.component';

@NgModule({
  declarations: [
    AdministrationDataPortalComponent,
    CensusComponent,
    AgeGroupsComponent,
    BeneficiariesComponent,
    AddCensusComponent,
    AddBeneficiaryComponent,
    AddAgeRangeComponent,
    PolicyDocumentsComponent,
    AddPolicyDocumentComponent
  ],
  exports: [
    AdministrationDataPortalComponent
  ],
  imports: [
    CommonModule, CoreModule, SharedModule
  ]
})
export class AdministrationDataPortalModule {
}
